if (!customElements.get('klaviyo-signup-form')) {
  customElements.define('klaviyo-signup-form', class KlaviyoSignupForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.messages = this.querySelector('[data-messages]');
      this.handleSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.handleSubmit);
    }

    async handleSubmit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const firstName = this.querySelector('[name="first_name"]').value.trim();
      const email = this.querySelector('[name="email"]').value.trim();
      const submitBtn = this.querySelector('[type="submit"]');

      if (submitBtn) submitBtn.disabled = true;

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              'revision': '2023-12-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email, first_name: firstName },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: { type: 'list', id: this.dataset.listId },
                  },
                },
              },
            }),
          }
        );

        if (res.status === 202) {
          this.showSuccess();
        } else {
          this.showError();
          if (submitBtn) submitBtn.disabled = false;
        }
      } catch {
        this.showError();
        if (submitBtn) submitBtn.disabled = false;
      }
    }

    showSuccess() {
      const richSuccess = this.dataset.richSuccess === 'true';

      if (richSuccess) {
        const section = this.closest('.waitlist-hero');
        if (section) {
          section.style.minHeight = section.offsetHeight + 'px';

          const defaultBg = section.querySelector('.waitlist-hero__background--default');
          const successBg = section.querySelector('.waitlist-hero__background--success');
          if (defaultBg) defaultBg.hidden = true;
          if (successBg) successBg.hidden = false;

          const mainContent = section.querySelector('.waitlist-hero__content:not(.waitlist-hero__success-content)');
          const successContent = section.querySelector('.waitlist-hero__success-content');
          if (mainContent) mainContent.hidden = true;
          if (successContent) {
            successContent.removeAttribute('hidden');
            successContent.focus();
          }
        }
      } else {
        const section = this.closest('.waitlist-hero');
        if (section) {
          const mainContent = section.querySelector('.waitlist-hero__content:not(.waitlist-hero__simple-success):not(.waitlist-hero__success-content)');
          const simpleSuccess = section.querySelector('.waitlist-hero__simple-success');
          if (mainContent) mainContent.hidden = true;
          if (simpleSuccess) {
            simpleSuccess.removeAttribute('hidden');
            simpleSuccess.focus();
          }
        }
      }
    }

    showError() {
      this.messages.textContent = this.dataset.errorMessage || 'Something went wrong. Please try again.';
      this.messages.removeAttribute('hidden');
    }
  });
}

// Shopify native form path: detect ?subscribed=true after page reload and show success state.
(function () {
  if (new URLSearchParams(window.location.search).get('subscribed') !== 'true') return;
  history.replaceState(null, '', window.location.pathname);

  const wrapper = document.querySelector('.waitlist-shopify-form');
  if (!wrapper) return;

  if (wrapper.dataset.richSuccess === 'true') {
    const section = wrapper.closest('.waitlist-hero');
    if (section) {
      const defaultBg = section.querySelector('.waitlist-hero__background--default');
      const successBg = section.querySelector('.waitlist-hero__background--success');
      if (defaultBg) defaultBg.hidden = true;
      if (successBg) successBg.hidden = false;

      const mainContent = section.querySelector('.waitlist-hero__content:not(.waitlist-hero__success-content)');
      const successContent = section.querySelector('.waitlist-hero__success-content');
      if (mainContent) mainContent.hidden = true;
      if (successContent) {
        successContent.removeAttribute('hidden');
        successContent.focus();
      }
    }
  } else {
    const section = wrapper.closest('.waitlist-hero');
    if (section) {
      const mainContent = section.querySelector('.waitlist-hero__content:not(.waitlist-hero__simple-success):not(.waitlist-hero__success-content)');
      const simpleSuccess = section.querySelector('.waitlist-hero__simple-success');
      if (mainContent) mainContent.hidden = true;
      if (simpleSuccess) {
        simpleSuccess.removeAttribute('hidden');
        simpleSuccess.focus();
      }
    }
  }
}());
